export default __webpack_public_path__ + "static/media/lain_main_theme.aeb759db.mp4";